import React from 'react';
// import { Link } from 'gatsby';
import Link from 'gatsby-plugin-transition-link/AniLink';
import {
  string,
  node,
  objectOf,
  oneOfType,
  number,
} from 'prop-types';
import styles from './DefaultLink.module.scss';
import variables from '../../styles/variables.module.scss';

const DefaultLink = props => {
  const {
    href,
    to,
    children,
    color,
    style,
    className,
  } = props;

  const onAnchor = () => {
    fbq('track', 'Contact');
    gtag('event', 'conversion', {
      send_to: 'AW-690899585/-sxpCOa5wbcBEIGVuckC',
    });
    window.location.href = href;
  };

  const renderUnderline = () => (
    <hr
      className={styles.linkUnderline}
      style={{ backgroundColor: color, cursor: 'pointer' }}
    />
  );

  const renderDefaultLink = () =>
    href ? (
      <div
        onClick={onAnchor}
        role="button"
        className={styles.linkContainer}
      >
        {React.cloneElement(children, {
          style: { color, cursor: 'pointer' },
        })}
        {renderUnderline()}
      </div>
    ) : (
      <Link fade to={to} className={styles.linkContainer}>
        {React.cloneElement(children, {
          style: { color, cursor: 'pointer' },
        })}
        {renderUnderline()}
      </Link>
    );

  return (
    <div
      className={[styles.linkMainContainer, className].join(
        ' '
      )}
      style={style}
    >
      {renderDefaultLink()}
    </div>
  );
};

DefaultLink.propTypes = {
  href: string,
  color: string,
  to: string,
  children: node.isRequired,
  style: objectOf(oneOfType([string, number])),
  className: string,
};

DefaultLink.defaultProps = {
  href: null,
  color: variables.springGreen,
  to: null,
  style: null,
  className: null,
};

export default DefaultLink;
